import { gql } from "@apollo/client";

export const getContributorsListQuery = gql`
    query getContributorsList(
        $elementsPerPage: Int
        $page: Int
        $orderBy: ContributorOrderByInput
        $where: ContributorWhereInput!
    ) {
        listContributors(elementsPerPage: $elementsPerPage, page: $page, orderBy: $orderBy, where: $where) {
            posts {
                appleId
                id
                name
                name_ar
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
            }
        }
    }
`;

export const getRoleMappingsListQuery = gql`
    query getRoleMappingsList($clientId: Int, $limit: Int, $page: Int, $search: String) {
        listRoleMappings(clientId: $clientId, limit: $limit, page: $page, search: $search) {
            posts {
                mappedName
                roleId
                roleName
            }
            meta {
                resultCount
                nodeCount
                currentPage
                totalPages
            }
        }
    }
`;

export const getContributorQuery = gql`
    query getContributor($where: ContributorWhereUniqueInput!) {
        contributor(where: $where) {
            appleId
            id
            name
            name_ar
        }
    }
`;
